// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2iakY","tab":"Tabs_tab__5IUWy","tabActive":"Tabs_tabActive__3oIya"};